(function (app, ng) {

    editPrimaryAdvisorController.$inject = ["$mdDialog", "clientApi", "advisorApi", "_"];
    app.controller("editPrimaryAdvisorController", editPrimaryAdvisorController);

    function editPrimaryAdvisorController($mdDialog, clientApi, advisorApi, _) {
        var $ctrl = this;
        $ctrl.ui = {};

        var errorAlert = $mdDialog.alert({
            title: "An error saving has occured.  Please try again.",
            ariaLabel: "Error alert",
            ok: "Ok",
            skipHide: true
        });

        $ctrl.dbAdvisor = ng.copy($ctrl.advisor);
        if ($ctrl.advisor)
            $ctrl.advisor.Term = $ctrl.advisor.Person.FirstName + " " + $ctrl.advisor.Person.LastName;

        ng.extend($ctrl,
        {
            close: close,
            searchAdvisors: searchAdvisors,
            clear: clear,
            save: save
        });

        function close() { return $mdDialog.cancel(); }

        function searchAdvisors(term) {
            return advisorApi.searchAdvisors(term).then(function (result) {
                _.remove(result, function (row) { return row.Id === $ctrl.client.Id; });
                ng.forEach(result,
                    function (row) {
                        row.Term = row.Person.FirstName + " " + row.Person.LastName;
                    });
                return result;
            });
        }

        function clear($event) {
            $ctrl.ui.deleting = true;
            var confirm = $mdDialog.confirm({
                title: "Are you sure you want to remove this advisor?",
                targetEvent: $event,
                ariaLabel: "Confirm primary advisor removal",
                ok: "Remove",
                cancel: "Cancel",
                skipHide: true,
                parent: $event.currentTarget.form,
                onComplete: function() {
                    var $dialog = ng.element(document.querySelector("md-dialog"));
                    var $actionsSection = $dialog.find("md-dialog-actions");
                    var $cancelButton = $actionsSection.children()[0];
                    $cancelButton.focus();
                }
            });
            if (!$ctrl.dbAdvisor) {
                $ctrl.advisor = null;
                $ctrl.ui.deleting = false;
            } else
                $mdDialog.show(confirm)
                    .then(function() {
                            return clientApi.removeClientPrimaryAdvisor($ctrl.client.Id)
                                .then(function() {
                                        $ctrl.ui.deleting = false;
                                        $mdDialog.hide();
                                    },
                                    function() {
                                        $ctrl.ui.deleting = false;
                                        errorAlert.parent($event.currentTarget.parentElement);
                                        $mdDialog.show(errorAlert);
                                    });
                        },
                        function () {
                            $ctrl.ui.deleting = false;
                        });
        }

        function save($event) {
            $ctrl.ui.saving = true;
            return clientApi.updateClientPrimaryAdvisor($ctrl.client.Id, $ctrl.advisor)
                .then(function() {
                        $ctrl.ui.saving = false;
                        $mdDialog.hide($ctrl.advisor);
                    },
                    function () {
                        $ctrl.ui.saving = false;
                        $mdDialog.show(errorAlert.targetEvent($event));
                    });
        }
    }
})(window.app, window.angular); //jshint ignore:line